import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WelcomeScreen } from '../components/welcome/WelcomeScreen';

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleSetupComplete = () => {
    // Navigate to chat page after successful setup
    navigate('/', { replace: true });
  };

  return (
    <WelcomeScreen onSetupComplete={handleSetupComplete} />
  );
};

export default WelcomePage;